import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { isDevEnv, isHomologEnv } from 'utils/env';

// Disable console log on production and homolog
//  pending see why homolog returning production
// Change before Sentry, allowing Sentry to log console messages but not show on the console ouput.
if (!isDevEnv && !isHomologEnv) {
  window.console = {
    ...window.console,
    info: () => {},
    log: () => {},
    warn: () => {},
  };
}

Sentry.init({
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_VERSION,
  integrations: [
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
    }),
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'Dev' ? 0.4 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.lkp\.app\.br/, /^https:\/\/.*\.lkp\.dev\.br/],
  // debug: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'Dev',
  replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'Dev' ? 1.0 : 0.4,
  replaysSessionSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'Dev' ? 1.0 : 0.3,
  _experiments: { enableLogs: true },
  // Erros do banner de cookies (tag.goadopt.io): script de terceiros, fora do nosso controle.
  ignoreErrors: [/AdOpt ERROR/],
  beforeSend(event) {
    const frames = event.exception?.values?.flatMap(value => value.stacktrace?.frames ?? []) ?? [];
    // O injector do AdOpt executa código sem URL própria, então o Sentry atribui esses frames
    // à URL da página (ex.: "/login at line 8:116497"). Se nenhum frame vem do nosso bundle
    // (/assets/ em prod, /src/ e /node_modules/ no dev), o erro não é nosso.
    const hasOwnFrame = frames.some(frame => /\/(assets|src|node_modules)\//.test(frame.filename ?? ''));
    if (frames.length && !hasOwnFrame) {
      return null;
    }
    return event;
  },
});
